import { render, staticRenderFns } from "./dashboard-top-sales.vue?vue&type=template&id=1a36de45&"
import script from "./dashboard-top-sales.vue?vue&type=script&lang=js&"
export * from "./dashboard-top-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports